export const CHANGE_GRAPH = "CHANGE_GRAPH";

export const CHECKBOX_FILTER_CHANGE = "CHECKBOX_FILTER_CHANGE";
export const TIMERANGE_FILTER_CHANGE = "TIMERANGE_FILTER_CHANGE";

export const PROJECT_HOVERED = "PROJECT_HOVERED";
export const LABEL_HOVERED = "LABEL_HOVERED";
export const YEAR_HOVERED = "YEAR_HOVERED";
export const UNHOVERED = "UNHOVERED";

export const PROJECT_CLICKED = "PROJECT_CLICKED";
export const LABEL_CLICKED = "LABEL_CLICKED";
export const YEAR_CLICKED = "YEAR_CLICKED";
export const INST_CLICKED = "INST_CLICKED";
export const UNCLICKED = "UNCLICKED";

export const SHOW_UNCERTAINTY = "SHOW_UNCERTAINTY";
export const HIGHLIGHT_UNCERTAINTY = "HIGHLIGHT_UNCERTAINTY";
export const LEGEND_HOVERED = "LEGEND_HOVERED";

export const UPDATE_DATA = "UPDATE_DATA";
export const UPDATE_TIME_DATA = "UPDATE_TIME_DATA";

export const TUTORIAL_STARTED = "TUTORIAL_STARTED";
export const PAGE_RESET = "PAGE_RESET";
export const SHARE_DIALOG_OPENED = "SHARE_DIALOG_OPENED";

export const PROCESS_DATA_IF_READY = "PROCESS_DATA_IF_READY";
